module.exports = __webpack_public_path__ + "img/cn-pro-1.2f060a9e.png";